export default "/images/cat-logo-5.png?10811caf83b23c88e600af3fc6807d6a";